export const CUSTOM_QUESTION_REG = new RegExp(
  /^([cvx]q|cl|tl)(\d+)(?:_(\d+))?(?:-(\d+))?(?:sq(\d+))?(?:a(\d+))?$/i,
  'i'
)

// Faithful port of the page-lib custom-question id pattern. Deliberately NOT the same as
// CUSTOM_QUESTION_REG above: this one accepts the `sn` (storytelling note) prefix and allows
// only a single `_N` / `-N` suffix, so the two are not interchangeable.
export const CUSTOM_QUESTION_ID_REG = /^([vcx]q|cl|tl|sn)(\d+)(?:[_-](\d+))?$/i

export const ALLOWED_HTML_TAGS = /<(b|i|u)>.*<\/\1>|[!@#$%^&*(),.?":{}]|<br>/imu

export const SENTIMENTS = [
  { value: 'None', sentiment: 0, type: 'sentiment', label: 'None' },
  { value: 'Negative', sentiment: 1, type: 'sentiment', label: 'Negative' },
  { value: 'Neutral', sentiment: 2, type: 'sentiment', label: 'Neutral' },
  { value: 'Positive', sentiment: 3, type: 'sentiment', label: 'Positive' },
  { value: 'Mixed', sentiment: 4, type: 'sentiment', label: 'Mixed' }
]

export const SENTIMENTS_ICON_HASH = {
  Mixed: 'mixed',
  Positive: 'positive',
  Negative: 'negative',
  None: 'unrated',
  Neutral: 'neutral'
}

export const CODEBOOK_MIN_LENGTH = 2
export const CODEBOOK_MAX_LENGTH = 53

export const TAG_MIN_LENGTH = 2
export const TAG_MAX_LENGTH = 53

export const CODEBOOKS_COLORS = [
  ['#76C893', '#C8E9D4'],
  ['#34A0A4', '#AED9DA'],
  ['#29ABE2', '#A9DDF3'],
  ['#1E6091', '#A5BFD3'],
  ['#00296B', '#99A9C4'],
  ['#25CED1', '#A8EBEC'],
  ['#FFBA08', '#FFE39C'],
  ['#FF7D00', '#FFCB99'],
  ['#D00000', '#EC9999'],
  ['#880D1E', '#CF9EA5'],
  ['#B23A48', '#E0B0B6'],
  ['#78290F', '#C9A99F'],
  ['#461220', '#B5A0A6'],
  ['#132A13', '#A1AAA1'],
  ['#31572C', '#ADBCAB'],
  ['#007F5F', '#99CCBF'],
  ['#90A955', '#D2DCBB'],
  ['#8AC926', '#D0E9A8'],
  ['#F84AA7', '#FCB6DC'],
  ['#B5179E', '#E1A2D8'],
  ['#A74482', '#DCB4CD'],
  ['#693668', '#C3AFC2'],
  ['#4B1281', '#B7A0CC'],
  ['#444444', '#B4B4B4']
]

export const CONFIDENCE_LEVELS = [
  [0.8, '80.0%'],
  [0.85, '85.0%'],
  [0.9, '90.0%'],
  [0.95, '95.0%'],
  [0.98, '98.0%'],
  [0.99, '99.0%'],
  [0.999, '99.9%']
]

// Question types that can be split by a demographic trait, and those the report can render as
// respondent counts. Ported from the question-view base (isTraitType / isRType).
export const TRAIT_QUESTION_TYPES = ['mx', 'sr', 'se', 'ro', 'aro', 'mp', 'ps', 'sft']
export const TRAIT_TYPES = ['rb', 'cb', 'cx', 'scx', 'oex', 'sh', 'ec', 'mn', 'sft', 'cn']
export const R_TYPES = ['cb', 'oex', 'sft']

// Question types whose batches carry the TURF candidates.
export const TURF_BATCH_TYPES = ['mx', 'sr', 'se']

// Question types a word cloud can render, once there are enough items to be worth one.
export const WC_QUESTION_TYPES = ['mx', 'sr', 'se', 'ro', 'aro', 'ps', 'mp']
export const WC_TYPES = ['rb', 'cb']
export const WC_MIN_ITEMS = 20

// Question types that can carry respondent verbatims, and those that are verbatims themselves.
export const VERBATIM_TYPES = ['rb', 'cb', 'oex', 'mx', 'mp', 'hm']
export const VERBATIM_OWN_TYPES = ['cx', 'scx', 'oe', 'cn', 'mn']

// An extended question addresses its parent for verbatims, so it is excluded by id.
export const EXTENDED_QUESTION_ID_REG = /^xq\d+(?:_\d+)?$/i

// The chart modes that leave a block with no chart at all: the report drawn as a map, or with the
// charts turned off. Deliberately not NON_CHART_MODES, which also holds the word-cloud mode -- that
// one draws a cloud in the chart's place rather than leaving the block without one.

// --- Shared by the comments page, the Coding tab and the search box -------------------------------
// Each starts on all questions, sorted by id, 250 to a page; the default codebook is the one a code
// lands in when none is named; the search box draws a batch label as markup only when it carries these.
export const DEFAULT_SELECTED_QUESTION = '*'
export const DEFAULT_CODEBOOK = 'Default codebook'
export const DEFAULT_ORDER_BY = 'id'
export const DEFAULT_PER_PAGE = 250
